import Pusher from 'pusher-js'

if (process.env.NODE_ENV !== 'production') {
  // Pusher.logToConsole = true
}

let pusherState = null

let pusherOptions = {
  authEndpoint: process.env.ROOT_API + '/api/v1/broadcasting/auth',
  auth: {
    headers: {
      'Accept': 'application/json'
    }
  },
  cluster: 'us3',
  forceTLS: true
}

function injectAuthorization () {
  pusherOptions.auth.headers['Authorization'] = 'Bearer ' + localStorage.getItem('authenticatedToken')
}

/*
if (localStorage.getItem('authenticatedToken')) {
  injectAuthorization()
  pusherState = new Pusher(process.env.PUSHER, pusherOptions)
}
*/

const state = {
  pusher: pusherState
}

const getters = {
  init: state => state.pusher
}

const actions = {
  initPusher ({ commit }) {
    if (!this.getters.authUser.via_share_link) {
      injectAuthorization()
      commit('initPusher', new Pusher(process.env.PUSHER, pusherOptions))
    }
  }
}

const mutations = {
  initPusher: (state, pusher) => {
    state.pusher = pusher
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/pusher.js